import classNames from "classnames";
import { useMemo } from "react";

function VideoTile(props) {
  const drawUserNameBox = props.drawUserNameBox;
  const username = props.username;
  const videoTags = props.videoTags;
  const activeSpeakerId = props.activeSpeakerId;
  const userId = props.userId;
  const hidden = props.hidden;

  const usernameComponent = useMemo(() => {
    return (
      <div
        className={classNames(
          "absolute text-white font-bold  opacity-50 bottom-0 left-0 px-4 ",
          activeSpeakerId === userId ? "bg-yellow-400" : "bg-gray-500"
        )}
      >
        {username}
      </div>
    );
  }, [activeSpeakerId, username, userId]);

  return (
    <div
      className={classNames(
        hidden ? "hidden" : "",
        "bg-gray-700 flex items-center justify-center relative m-1 rounded-lg shadow-lg"
      )}
    >
      {drawUserNameBox ? (
        <div className="text-white bg-yellow-500 w-20 h-20 rounded-full flex items-center justify-center font-bold text-4xl">
          {username[0].toUpperCase()}
          {videoTags}
        </div>
      ) : (
        <div className="flex items-center justify-center w-full h-full">{videoTags}</div>
      )}

      {usernameComponent}
    </div>
  );
}

export default VideoTile;
